// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AgendaDeletarServicoNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Nested input for servicos array in Agenda_DeletarCompromissoInput
 */
import { registerContract } from './validate'

export interface AgendaDeletarServicoNestedInput {
orcamento_servico_id: number
}

registerContract('AgendaDeletarServicoNestedInput', {
  orcamento_servico_id: { type: 'number',  required: true },
})
